import React from 'react'
import { GridSelectionHLPure, PanelBarGLPure } from '../../pures'

function FollowUpDocumentFiles(props) {
    const {
        t,
        documentData,
        selectedFile,
        setSelectedFile
    } = props;

    const cellColumnOne = (props) => {
        const { dataItem } = props;
        return <td className={`digitalVaultFollowUpDocument-grid-col1 ${dataItem.selected ? 'selected' : ''}`} >
            <div>
                {dataItem.name}
            </div>
        </td>
    }

    return (
        <PanelBarGLPure
            expandedPanel={false}
            titlePanel={t("documentPanelBarExpediente-docs")}
        >
            <div className="digitalVaultFollowUpDocument-grid">
                <GridSelectionHLPure
                    dataGrid={documentData.files.map(file => file.id == selectedFile?.id ? { ...file, selected: true } : file)}
                    skip={0}
                    take={documentData.files.length}
                    pageable={false}
                    styleGrid={{ maxHeight: '320px' }}

                    titleRow1={t("followUpDocumentFiles.labels.title.1")}
                    cellColumnOne={cellColumnOne}
                    widthHeader={"digitalVaultFollowUpDocument-grid-col1"}

                    columnFive
                    headerColumnFiveClass={"digitalVaultFollowUpDocument-cellActions"}
                    columnFiveStyleClass={"digitalVaultFollowUpDocument-cellActions"}
                    titleRow5={""}
                    iconOneActive
                    labelOneActions={t("followUpDocumentFiles.labels.title.4")}
                    activeDialog1
                    mobileFunction
                    btnOpenDialog1={(file) => setSelectedFile(file)}

                    onSelectedItem={() => { }}
                    setNameComponentUser={() => { }}
                    setShowDetails={() => { }}
                />
            </div>
        </PanelBarGLPure>
    )
}

export default FollowUpDocumentFiles